import React from 'react';

interface LocationIconProps {
  className?: string;
  color?: string;
  size?: number;
}

const LocationIcon: React.FC<LocationIconProps> = ({
  className = '',
  color = 'white',
  size = 24,
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ color }}
    >
      <path
        d="M7.4632 19.3303H5.54315C2.60315 19.1203 1.2832 16.8603 1.2832 14.8503C1.2832 12.8403 2.60316 10.5703 5.49316 10.3703C5.90316 10.3303 6.26315 10.6503 6.29315 11.0703C6.32315 11.4803 6.0132 11.8403 5.5932 11.8703C3.6532 12.0103 2.7832 13.4703 2.7832 14.8603C2.7832 16.2503 3.6532 17.7103 5.5932 17.8503H7.4632C7.8732 17.8503 8.2132 18.1903 8.2132 18.6003C8.2132 19.0103 7.8732 19.3303 7.4632 19.3303Z"
        fill="currentColor"
      />
      <path
        d="M16.6728 19.3302C16.6528 19.3302 16.6428 19.3302 16.6228 19.3302C16.2128 19.3302 15.8329 18.9902 15.8329 18.5802C15.8329 18.1502 16.1529 17.8302 16.5729 17.8302C17.8029 17.8302 18.9029 17.4002 19.7629 16.6302C21.3229 15.2702 21.4228 13.3102 21.0028 11.9302C20.5828 10.5602 19.4128 8.99024 17.3728 8.74024C17.0428 8.70024 16.7828 8.45024 16.7228 8.12024C16.3228 5.72024 15.0329 4.06024 13.0729 3.46024C11.0529 2.83024 8.69281 3.45024 7.22281 4.99024C5.79281 6.48024 5.46282 8.57024 6.29282 10.8702C6.43282 11.2602 6.23287 11.6902 5.84287 11.8302C5.45287 11.9702 5.02285 11.7702 4.88285 11.3802C3.87285 8.56024 4.33286 5.86024 6.14286 3.96024C7.99286 2.02024 10.9629 1.25023 13.5129 2.03023C15.8529 2.75023 17.5028 4.68023 18.1028 7.36023C20.1428 7.82023 21.7828 9.37024 22.4328 11.5102C23.1428 13.8402 22.5028 16.2402 20.7528 17.7602C19.6428 18.7602 18.1928 19.3302 16.6728 19.3302Z"
        fill="currentColor"
      />
      <path
        d="M12.0029 22.2703C9.99293 22.2703 8.11295 21.2003 7.08295 19.4703C6.97295 19.3003 6.86295 19.1003 6.77295 18.8803C6.43295 18.1703 6.25293 17.3603 6.25293 16.5203C6.25293 13.3503 8.83293 10.7703 12.0029 10.7703C15.1729 10.7703 17.7529 13.3503 17.7529 16.5203C17.7529 17.3703 17.573 18.1703 17.213 18.9103C17.133 19.1003 17.023 19.3003 16.903 19.4903C15.893 21.2003 14.0129 22.2703 12.0029 22.2703ZM12.0029 12.2703C9.66293 12.2703 7.75293 14.1803 7.75293 16.5203C7.75293 17.1403 7.88293 17.7203 8.13293 18.2503C8.21293 18.4203 8.28292 18.5603 8.36292 18.6903C9.12292 19.9803 10.5129 20.7703 11.9929 20.7703C13.4729 20.7703 14.8629 19.9803 15.6129 18.7103C15.7029 18.5603 15.783 18.4203 15.843 18.2803C16.113 17.7303 16.2429 17.1503 16.2429 16.5303C16.2529 14.1803 14.3429 12.2703 12.0029 12.2703Z"
        fill="currentColor"
      />
      <path
        d="M11.4328 18.2602C11.2428 18.2602 11.0529 18.1902 10.9029 18.0402L9.91281 17.0502C9.62281 16.7602 9.62281 16.2802 9.91281 15.9902C10.2028 15.7002 10.6828 15.7002 10.9728 15.9902L11.4529 16.4702L13.0528 14.9902C13.3628 14.7102 13.8328 14.7302 14.1128 15.0302C14.3928 15.3302 14.3728 15.8102 14.0728 16.0902L11.9428 18.0602C11.7928 18.1902 11.6128 18.2602 11.4328 18.2602Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default LocationIcon;
